(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kkp-common-logistics"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.kkp-network [data-kkp-route-map]';
  const initialized = new WeakMap();
  const played = new Set();
  const active = new Set();
  const motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  const svgNamespace = 'http://www.w3.org/2000/svg';

  const restoreStyle = (element, value) => {
    if (value === null) element.removeAttribute('style');
    else element.setAttribute('style', value);
  };

  const finish = (state, status = 'complete') => {
    if (state.frame) window.cancelAnimationFrame(state.frame);
    state.frame = 0;
    if (state.observer) state.observer.disconnect();
    state.entries.forEach((entry) => {
      restoreStyle(entry.path, entry.pathStyle);
      restoreStyle(entry.halo, entry.haloStyle);
      if (entry.marker === null) entry.path.removeAttribute('marker-end');
      else entry.path.setAttribute('marker-end', entry.marker);
      if (entry.head) entry.head.remove();
    });
    state.status = status;
    state.map.dataset.kkpMotion = status;
    active.delete(state);
  };

  const start = (state) => {
    if (state.status !== 'waiting') return;
    state.status = 'running';
    state.map.dataset.kkpMotion = 'running';
    played.add(state.key);
    state.observer.disconnect();
    const began = performance.now();

    const tick = (now) => {
      state.frame = 0;
      if (!state.map.isConnected || motion.matches) {
        finish(state);
        return;
      }
      let complete = true;
      try {
        state.entries.forEach((entry, index) => {
          const progress = Math.min(1, Math.max(0, (now - began - (index % 4) * 140) / 1100));
          if (progress < 1) complete = false;
          const eased = 1 - (1 - progress) * (1 - progress);
          const distance = eased * entry.length;
          const offset = String(entry.length - distance);
          entry.path.style.strokeDashoffset = offset;
          entry.halo.style.strokeDashoffset = offset;
          entry.path.style.opacity = progress > 0 ? '1' : '0';
          entry.halo.style.opacity = progress > 0 ? '1' : '0';
          const point = entry.path.getPointAtLength(distance);
          const previous = entry.path.getPointAtLength(Math.max(0, distance - 1));
          const angle = Math.atan2(point.y - previous.y, point.x - previous.x) * 180 / Math.PI;
          entry.head.setAttribute('transform', `translate(${point.x} ${point.y}) rotate(${angle})`);
          entry.head.style.opacity = progress > 0 ? '1' : '0';
        });
      } catch {
        finish(state);
        return;
      }
      if (complete) finish(state);
      else state.frame = window.requestAnimationFrame(tick);
    };

    state.frame = window.requestAnimationFrame(tick);
  };

  const initializeMap = (map) => {
    if (initialized.has(map)) return;
    const key = map.dataset.kkpMotionId || map;
    const state = { map, key, entries: [], observer: null, frame: 0, status: 'static' };
    initialized.set(map, state);
    if (played.has(key) || !motion || motion.matches || !window.IntersectionObserver || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
      map.dataset.kkpMotion = played.has(key) ? 'complete' : 'static';
      return;
    }

    const paths = [...map.querySelectorAll('[data-kkp-route]')];
    const halos = [...map.querySelectorAll('[data-kkp-route-halo]')];
    if (paths.length !== 8 || halos.length !== paths.length) return;

    try {
      state.entries = paths.map((path, index) => {
        const length = path.getTotalLength();
        if (!Number.isFinite(length) || length <= 0 || path.getAttribute('d') !== halos[index].getAttribute('d')) throw new Error('Invalid route');
        path.getPointAtLength(length);
        return { path, halo: halos[index], length, marker: path.getAttribute('marker-end'), pathStyle: path.getAttribute('style'), haloStyle: halos[index].getAttribute('style'), head: null };
      });

      state.observer = new window.IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.3)) start(state);
      }, { threshold: 0.3, rootMargin: '0px 0px -8% 0px' });

      state.entries.forEach((entry) => {
        entry.path.setAttribute('marker-end', 'none');
        [entry.path, entry.halo].forEach((path) => {
          path.style.strokeDasharray = `${entry.length} ${entry.length}`;
          path.style.strokeDashoffset = String(entry.length);
          path.style.opacity = '0';
        });
        entry.head = document.createElementNS(svgNamespace, 'path');
        entry.head.setAttribute('d', 'M-11.2-5.6L0 0L-11.2 5.6Z');
        entry.head.setAttribute('fill', '#07533b');
        entry.head.setAttribute('stroke', 'none');
        entry.head.setAttribute('aria-hidden', 'true');
        entry.head.setAttribute('data-kkp-moving-head', '');
        entry.head.style.opacity = '0';
        entry.path.parentNode.appendChild(entry.head);
      });

      state.status = 'waiting';
      map.dataset.kkpMotion = 'waiting';
      active.add(state);
      state.observer.observe(map);
    } catch {
      finish(state, 'static');
    }
  };

  const initializeWithin = (root) => {
    root.querySelectorAll(selector).forEach(initializeMap);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  else initializeWithin(document);

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    [...active].filter((state) => event.target.contains(state.map)).forEach((state) => finish(state));
  });
  const reduceMotion = (event) => {
    if (event.matches) [...active].forEach((state) => finish(state, 'static'));
  };
  if (motion && motion.addEventListener) motion.addEventListener('change', reduceMotion);
  else if (motion && motion.addListener) motion.addListener(reduceMotion);
  window.addEventListener('pagehide', (event) => {
    [...active].filter((state) => state.status === 'running' || !event.persisted).forEach((state) => finish(state));
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    [...active].filter((state) => state.status === 'waiting').forEach((state) => {
      state.observer.disconnect();
      state.observer.observe(state.map);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
